import type { ReactNode } from "react";

export function FormField({
  label,
  htmlFor,
  error,
  children,
  required,
}: {
  label: string;
  htmlFor?: string;
  error?: string;
  children: ReactNode;
  required?: boolean;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={htmlFor} className="text-sm font-medium text-night-blue">
        {label}
        {required && <span className="text-happy-red-ink"> *</span>}
      </label>
      {children}
      {error && <span className="text-xs text-happy-red-ink">{error}</span>}
    </div>
  );
}
